import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.query-funkprotokoll-mandant-options';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenQueryFunkprotokollMandantOptionsEffects {

    QueryFunkprotokollMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_QUERY_FUNKPROTOKOLL_MANDANT_OPTIONS),
        mergeMap((x: ac.PostQueryFunkprotokollMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postQueryFunkprotokollMandantOptions().pipe(
                map((result: any) => {
                    return new ac.PostQueryFunkprotokollMandantOptionsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostQueryFunkprotokollMandantOptionsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollQueryService);
        }
        return this.service;
    }
}
